<template>
    <ExpandedLayout content_class='compose'>
        <template #content>
            <ComposeSection v-if="compose_controller"
              :webmail_view="webmail_view"
              :contacts_controller="ContactsController"
              :identities_controller="IdentitiesController"
              :state_consumer="StateConsumer"
              :compose_controller="compose_controller"
            />
        </template>
    </ExpandedLayout>
</template>

<script setup>
  import {ref,reactive}       from 'vue';
  import {onBeforeMount}      from 'vue';
  import {defineProps}        from 'vue';
  import ComposeSection       from './Sections/ComposeSection.vue';
  import ExpandedLayout       from '@/vue/Layouts/ExpandedLayout.vue';
  import ContactsController   from '@/js/Contacts/ContactsController';
  import IdentitiesController from '@/js/Settings/Identities/IdentitiesController';
  import StateConsumer        from '@/js/Shared/State/StateConsumer';
  import ComposeController    from '@/js/Compose/ComposeController';

  const props = defineProps({
    webmail_view: {},
  })

  var compose_controller = ref();

  onBeforeMount(() => {
    setComposeController();
  })

  const setComposeController = () => {
    if (StateConsumer.peek('compose_controller')) {
      compose_controller.value = StateConsumer.consume('compose_controller');
      return;
    }

    compose_controller.value = reactive(new ComposeController());
  }


</script>

